import React from 'react';
import classNames from 'classnames';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { PORDUCT_TAG_MAP } from '@/constants/global';
import Layout from '@/layouts';
import { getProductCaseDetails, getProductDetail, getOtherCaseList } from '@/services/product';
// import { Product, RecommendProduct } from '@/interface/product';
import Footer from '@/components/footer';
import ProductCaseCard from '@/business-components/PorudctCaseCard';
import ProductTag from '../../../components/ProductTag';
import styles from './index.module.scss';

export const getServerSideProps: GetServerSideProps = async ({ params, res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=59, stale-while-revalidate=119');
  const { caseid, id: boxProductId } = params;
  console.log('params :>> ', params);
  try {
    const [{ data: caseDetail }, { data: productDetail }, { data: caseDetailsList }] = await Promise.all([
      getProductCaseDetails(caseid as string).catch(() => {
        return null;
      }),
      getProductDetail(boxProductId as string).catch(() => {
        return null;
      }),
      getOtherCaseList({
        boxProductCaseId: caseid as string,
        boxProductId: boxProductId as string,
        pageIndex: 1,
        pageSize: 2,
      }).catch(() => {
        const data = { list: [], total: 0 };
        return { data };
      }),
    ]);
    return {
      props: {
        caseDetailsList: caseDetailsList?.list || [],
        caseDetail,
        productDetail,
      },
    };
  } catch (e) {
    return {
      props: {
        caseDetailsList: [],
        caseDetail: null,
        productDetail: null,
      },
    };
  }
};

function CbndataBoxPage({
  caseDetail,
  caseDetailsList,
  productDetail,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout
      title="Martech企服商店-企服点评平台-SaaS应用商店 | CBNData"
      description="第一财经商业数据中心（CBNData）隶属于上海文化广播影视集团（SMG），是国内领先的消费研究机构及数字化增长服务商。CBNDataBox是专业的Martech企服应用商店，围绕企业内营销流程的需求场景，为消费行业的营销&运营人员整合优质的Martech企服工具。"
      keyword="企业服务,企业服务工具,CBNData企服商店,公司点评,企服点评,SaaS商店,应用商店,大数据,SaaS服务,客户管理,营销数据,市场营销,创业服务,营销决策,管理工具"
      isShowNavBar
      FooterComponent={Footer}
      // isFrapMain
    >
      <div className={styles.caseDetails}>
        <header className={classNames('flex-row-nowrap', 'flex-center-center', styles.header)}>
          <div className={styles.headerTitle}>{caseDetail?.title}</div>
        </header>
        <section className={styles.innerContent}>
          <a
            className={classNames('flex-row-nowrap', 'flex-between-center', styles.productCard)}
            href={`/cbndatabox-new/product/${productDetail?.boxProductId}`}
          >
            <div className={styles.productCardLogo}>
              <img src={productDetail?.productLogo} className={styles.productCardLogoImg} />
            </div>
            <div className={classNames('flex-column-nowrap', styles.productCardContent)}>
              <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.productCardContentTit)}>
                <span className={styles.productCardContentTitText}>{productDetail?.productName}</span>
                <ProductTag
                  text={PORDUCT_TAG_MAP[productDetail?.angleMark]?.text}
                  bgColor={PORDUCT_TAG_MAP[productDetail?.angleMark]?.bgColor}
                />
              </div>
              <div className={styles.productCardContentSubTit}>{productDetail?.summary}</div>
            </div>
          </a>
          <div className={styles.caseDetailsContent}>
            <div className={styles.caseDetailsContentTit}>案例详情</div>
            <div
              className={styles.caseDetailsSection}
              data-class="editor-content"
              dangerouslySetInnerHTML={{ __html: caseDetail?.caseContent }}
            ></div>
          </div>
        </section>
        {caseDetailsList && caseDetailsList.length > 0 && (
          <footer className={styles.footerContent}>
            <div className={styles.otherCase}>
              <div className={styles.otherCaseTit}>{productDetail?.productName}的其他案例</div>
              <div className={classNames('flex-row-nowrap', 'flex-between-center')}>
                {caseDetailsList.slice(0, 2).map(item => (
                  <ProductCaseCard
                    width={318}
                    key={item.boxProductCaseId}
                    title={item.title}
                    boxProductId={item.boxProductId}
                    boxProductCaseId={item.boxProductCaseId}
                    companyNumEmployee={item.companyNumEmployee}
                    companyAddress={item.companyAddress}
                    companyName={item.companyName}
                  />
                ))}
              </div>
            </div>
          </footer>
        )}
      </div>
    </Layout>
  );
}

export default CbndataBoxPage;
